let env_type = process.env.NODE_ENV || 'production';

if (
	window.location.host.startsWith('dev') ||
	window.location.host.startsWith('viewers-ev') ||
	window.location.host.startsWith('app.sandbox') ||
	window.location.host.startsWith('dashboard.sandbox') ||
	window.location.host.startsWith('localhost') ||
	window.location.host.startsWith('sandbox')
) {
	env_type = 'development';
}

if (process.env.REACT_APP_ARG === 'prod') {
	env_type = 'production';
}

const config = {
	development: {
		apiKey: 'AIzaSyCtaNzeKuczQRCMJT-N-DxevX5-X5FuUWU',
		authDomain: 'dev-eventovirtual.firebaseapp.com',
		databaseURL: 'https://dev-eventovirtual.firebaseio.com',
		projectId: 'dev-eventovirtual',
		storageBucket: '',
		messagingSenderId: '182649736370',
		appId: '1:182649736370:web:415429d90b4bfc07',
	},
	production: {
		apiKey: 'AIzaSyA3bMYeVuXihpftjxQk0H38eq2b3B21_28',
		authDomain: 'app.eventovirtual.co',
		databaseURL: 'https://eventovirtual-co.firebaseio.com',
		projectId: 'eventovirtual-co',
		storageBucket: 'eventovirtual-co.appspot.com',
		messagingSenderId: '93481019476',
	},
};

export default config[env_type];
